import { BasketballLeagueDbb } from '@hefe/models';
import { BasketballLeaguesSlice } from '@hefe/store';
import { Col, Input, List, Row, Space, Steps, Tooltip } from 'antd';
import { t } from '@hefe/i18n';
import { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { useAppDispatch } from '../../../../store/store';
import { QuestionCircleOutlined } from '@ant-design/icons';

export default function AddLeagueAssistentLeagueSelection() {
  const dispatch = useAppDispatch();

  const [loadingLeagueId, setLoadingLeagueId] = useState(false);

  const leagueState = useSelector(
    BasketballLeaguesSlice.basketballLeaguesStateSelector
  );

  const dbbRequestData = useSelector(
    BasketballLeaguesSlice.basketballLeagueAssistentSelector
  );

  const listData = useSelector(
    BasketballLeaguesSlice.basketballLeagueDbbSelectionCurrentStepDataSelector
  );

  const dbbLeagueSelection = dbbRequestData.dbbLeagueSelection;

  useEffect(() => {
    fetchData();
  }, []);

  const fetchData = (value?: string) => {
    const requestData =
      BasketballLeaguesSlice.getDbbBasketballLeagueRequestData(
        leagueState,
        value
      );
    dispatch(BasketballLeaguesSlice.fetchDbbBasketballLeagues(requestData));
  };

  const onListItemClick = (
    item:
      | BasketballLeaguesSlice.DbbLeagueSelectionResponseData
      | BasketballLeagueDbb
  ) => {
    const currentStep = dbbLeagueSelection.currentStep;

    if (currentStep !== 6) {
      const selectedItem =
        item as BasketballLeaguesSlice.DbbLeagueSelectionResponseData;
      dispatch(
        BasketballLeaguesSlice.basketballLeaguesActions.setDbbLeagueSelectionData(
          {
            text: renderListItemLabel(selectedItem),
            value: [selectedItem?.id?.toString()],
          }
        )
      );

      fetchData(selectedItem.id + '');
    } else {
      // Save selected League and continue
      dispatch(
        BasketballLeaguesSlice.basketballLeaguesActions.setSelectedLeague(
          item as BasketballLeagueDbb
        )
      );
    }
  };

  const onStepClick = (step: number) => {
    dispatch(
      BasketballLeaguesSlice.basketballLeaguesActions.setDbbLeagueSelectionStep(
        step
      )
    );
  };

  const onLeagueIdSearch = (value: string) => {
    const leagueId = parseInt(value);
    if (value.length > 0 && !isNaN(leagueId)) {
      setLoadingLeagueId(true);
      dispatch(BasketballLeaguesSlice.fetchDbbBasketballLeague(leagueId))
        .unwrap()
        .then((league: BasketballLeagueDbb) => {
          dispatch(
            BasketballLeaguesSlice.basketballLeaguesActions.setSelectedLeague(
              league
            )
          );
        })
        .finally(() => setLoadingLeagueId(false));
    }
  };

  const renderListItemLabel = (item: any) => {
    const currentStep = dbbLeagueSelection.currentStep;

    switch (currentStep) {
      case 1:
        return `${
          item.bezirk ??
          t('leagues.assistant.select_league.association_leagues')
        } (${item.hits})`;
      case 3:
        return `${item.akg} ${item.geschlecht} (${item.hits})`;
      case 6:
        // eslint-disable-next-line no-case-declarations
        const league = item as BasketballLeagueDbb;
        return `${league.liganame}`;
      default:
        return `${item.label} (${item.hits})`;
    }
  };

  return (
    <Row>
      <Col xs={24} md={6}>
        <Steps
          direction="vertical"
          current={dbbLeagueSelection.currentStep}
          style={{ cursor: 'pointer' }}
        >
          <Steps.Step
            onClick={() => onStepClick(0)}
            title={t('leagues.assistant.select_league.association')}
            description={BasketballLeaguesSlice.getDbbBasketballLeagueSelectedValueForStep(
              leagueState,
              0
            )}
          />
          <Steps.Step
            onClick={() => onStepClick(1)}
            title={t('leagues.assistant.select_league.area')}
            description={BasketballLeaguesSlice.getDbbBasketballLeagueSelectedValueForStep(
              leagueState,
              1
            )}
          />
          <Steps.Step
            onClick={() => onStepClick(2)}
            title={t('leagues.assistant.select_league.type')}
            description={BasketballLeaguesSlice.getDbbBasketballLeagueSelectedValueForStep(
              leagueState,
              2
            )}
          />
          <Steps.Step
            onClick={() => onStepClick(3)}
            title={t('leagues.assistant.select_league.sex')}
            description={BasketballLeaguesSlice.getDbbBasketballLeagueSelectedValueForStep(
              leagueState,
              3
            )}
          />
          <Steps.Step
            onClick={() => onStepClick(4)}
            title={t('leagues.assistant.select_league.age')}
            description={BasketballLeaguesSlice.getDbbBasketballLeagueSelectedValueForStep(
              leagueState,
              4
            )}
          />
          <Steps.Step
            onClick={() => onStepClick(5)}
            title={t('leagues.assistant.select_league.division')}
            description={BasketballLeaguesSlice.getDbbBasketballLeagueSelectedValueForStep(
              leagueState,
              5
            )}
          />
          <Steps.Step
            onClick={() => onStepClick(6)}
            title={t('leagues.assistant.select_league.league')}
          />
        </Steps>
      </Col>
      <Col xs={24} md={18}>
        <Space direction="vertical" style={{ width: '100%' }}>
          <Space>
            <Input.Search
              loading={loadingLeagueId}
              type="search"
              placeholder={t('leagues.assistant.select_league.enter_league_id')}
              onSearch={onLeagueIdSearch}
            />
            <Tooltip
              title={t('leagues.assistant.select_league.league_id_info')}
            >
              <QuestionCircleOutlined />
            </Tooltip>
          </Space>
          <List
            loading={dbbLeagueSelection.isLoading}
            size="small"
            bordered
            dataSource={listData as any[]}
            renderItem={(item) => (
              <List.Item
                key={item.id}
                style={{ cursor: 'pointer' }}
                onClick={() => onListItemClick(item)}
              >
                {renderListItemLabel(item)}
              </List.Item>
            )}
          />
        </Space>
      </Col>
    </Row>
  );
}
